<template>
    <div class="agreement">
        <agreement-modal
            :title="info[type].title"
            :html="info[type].html"
            @close="closeAgreementModal"
            v-if="agreementContentsModal"
        />
        <div class="header" @click="gohome">← 홈화면으로 돌아가기</div>
        <div class="wrapper">
            <div class="agree-area">
                <div class="title">건강 측정 체험을 위해<br><span style="font-weight: 700;">약관 동의가 필요합니다</span></div>
                <div class="agree-component" style="margin-top: 4.6vh;">
                    <div class="text2" @click="agreementContentsView(0)">
                        <div class="row">
                            <span @click="agree1 = !agree1">[필수] 서비스 이용약관 동의</span>
                        </div>
                        <img style="width: 5vw;" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                    <div class="text2" @click="agreementContentsView(1)">
                        <div class="row">
                            <span @click="agree2 = !agree2">[필수] 개인정보 수집 및 이용동의</span>
                        </div>
                        <img style="width: 5vw;" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                    <div class="text2" @click="agreementContentsView(2)">
                        <div class="row">
                            <span @click="agree3 = !agree3">[필수] 민감정보(건강데이터) 처리 동의</span>
                        </div>
                        <img style="width: 5vw;" src="../../assets/showcase/xi/right_arrow.png" />
                    </div>
                </div>
                <div class="button-next-active" style="margin-top: 4.6vh;" @click="next">모두 동의합니다</div>
            </div>
        </div>
    </div>
</template>

<script>

import AgreementModal from '@/components/showcase/AgreementModal';
export default {
    components: { AgreementModal },
    data: function()
    {
        return {
            timerId: null,
            allAgree: false,
            agree1: false,
            agree2: false,
            agree3: false,
            agreementContentsModal: false,
            type: 0,
            info: [
                {title: "서비스 이용약관 동의", html: `<!DOCTYPE html>
<html lang="ko">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>서비스 이용약관</title>
    <style>
        body {
            font-size: 15px;
            word-break: break-word;
        }

        p {
            word-break: break-word;
        }
         .title {
            font-size: 20px;
            font-weight: bold;
         }
    </style>
</head>
<body>
    <h1>서비스 이용약관 동의</h1>

<h3>제 1 조 (목적)</h3>
이 약관은 솔닥 주식회사(이하 “회사”)가 제공하는 건강측정기기 측정 및 결과 안내 서비스(이하 “서비스”)의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및 책임 사항을 규정함을 목적으로 합니다.<br><br>

<h3>제 2 조 (용어의 정의)</h3>
1. “서비스”란 현장에 설치된 건강 측정 기기(체성분 분석기 등)를 통해 이용자의 건강 데이터를 측정하고, 그 결과를 모바일 등으로 확인·관리할 수 있도록 제공하는 제반 서비스를 말합니다.<br>
2. “이용자”란 본 약관에 동의하고 회사가 제공하는 서비스를 이용하는 고객을 말합니다.<br>
3. “건강측정기기”란 회사가 서비스 제공을 위해 현장에 설치한 혈압계, 신장계, 체성분 분석기, 악력계 등의 하드웨어 장치를 의미합니다.<br><br>

<h3>제 3 조 (약관 등의 명시와 설명 및 개정)</h3>
1. “회사”는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 화면(키오스크 등)에 게시합니다.<br>
2. “회사”는 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br>
3. “회사”가 약관을 개정할 경우에는 적용 일자 및 개정 사유를 명시하여 현행 약관과 함께 회사의 웹사이트 또는 서비스 화면에 그 적용 일자 7일 이전부터 공지합니다. 다만, 이용자에게 불리하게 약관 내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예 기간을 두고 공지합니다.<br>
4. 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계 법령 또는 상관례에 따릅니다.<br><br>

<h3>제 4 조 (서비스의 내용 및 변경)</h3>
1. 회사는 이용자에게 다음 각 호의 서비스를 제공합니다.<br>
&nbsp;&nbsp;1) 건강측정기기를 이용한 신체 데이터(혈압, 신장, 체성분, 악력 등) 측정 지원<br>
&nbsp;&nbsp;2) 측정된 데이터의 결과 리포트 전송 (카카오톡 알림톡)<br>
&nbsp;&nbsp;3) 건강 데이터 측정 이력 조회 (솔닥 ‘내건강’ 웹페이지)<br>
&nbsp;&nbsp;4) 기타 “회사”가 정하는 건강 관련 콘텐츠 제공<br>
2. 서비스 제공을 위한 측정기기의 종류와 구성은 설치된 현장의 상황에 따라 변경될 수 있습니다.<br>
3. “회사”는 기술적 사양의 변경, 기기의 고장, 현장 사정 등의 경우에는 장차 제공할 서비스의 내용을 변경하거나 중단할 수 있습니다.<br><br>

<h3>제 5 조 (서비스의 중단)</h3>
1. “회사”는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절, 기기 점검 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.<br>
2. “회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.<br><br>

<h3>제 6 조 (이용 계약의 성립 및 종료)</h3>
1. 이용 계약은 이용자가 현장에 설치된 기기 또는 연결된 모바일 화면에서 본 약관에 동의하고, 휴대전화 번호를 입력하여 측정을 시작함으로써 성립합니다.<br>
2. 이용자는 원활한 서비스 이용 및 결과 리포트 수신을 위해 본인의 정확한 휴대전화 번호를 입력해야 합니다.<br>
3. 타인의 휴대전화 번호를 도용하거나 오입력하여 발생하는 결과 리포트 오발송, 개인정보 노출 등의 문제에 대한 책임은 이용자 본인에게 있으며, 회사는 이에 대해 책임을 지지 않습니다.<br>
4. 만 14세 미만 아동의 경우, 법정대리인의 동의 및 동반 하에 서비스를 이용해야 하며, 이에 따르지 않아 발생하는 문제에 대해 회사는 책임을 지지 않습니다.<br>
5. 이용자가 개인정보(건강데이터) 삭제를 요청하거나 회사의 개인정보 처리방침에 따른 보존 기간이 만료된 경우 이용 계약은 종료됩니다.<br><br>

<h3>제 7 조 (개인정보 보호)</h3>
1. “회사”는 서비스 제공을 위하여 필요한 최소한의 정보(휴대전화 번호, 건강측정 데이터 등)를 수집합니다.<br>
2. “회사”는 이용자의 개인정보를 관련 법령 및 회사의 “개인정보 처리방침”에 따라 보호하고 관리합니다. 개인정보의 수집 및 이용에 대한 상세한 내용은 별도로 고지되는 개인정보 처리방침을 따릅니다.<br><br>

<h3>제 8 조 (이용자의 의무 및 주의사항)</h3>
이용자는 다음 행위를 하여서는 안 됩니다.<br>
1. 서비스 이용 시 허위 내용(타인 번호 등)의 등록<br>
2. 건강측정기기의 안내된 올바른 측정 방법을 따르지 않고 기기를 오용하는 행위<br>
3. 건강측정기기 및 관련 설비를 고의로 파손, 분해, 조작하거나 서비스의 운영을 방해하는 행위<br>
4. “서비스”를 이용하여 얻은 정보를 “회사”의 사전 승낙 없이 영리 목적으로 이용하거나 제3자에게 배포하는 행위<br>
5. 기타 관련 법령 규정 및 공서양속에 어긋나는 행위<br><br>
※ 본 서비스에서 제공하는 건강 정보는 참고용 데이터이며, 회사는 이용자가 이 정보를 의학적으로 맹신하여 발생한 결과에 대해 책임을 지지 않습니다. 건강에 이상이 있는 경우 반드시 병원을 방문하여 의사의 진료를 받으셔야 합니다.<br><br>

<h3>제 9 조 (서비스 내용의 한계 및 면책)</h3>
1. 본 서비스는 이용자의 일상적인 건강 관리를 돕기 위한 보조적 수단입니다. 제공되는 모든 측정 데이터와 분석 결과는 의학적 진단, 진료, 치료를 목적으로 하지 않으며, 전문 의료인의 상담이나 진료를 대체할 수 없습니다.<br>
2. “회사”는 이용자가 서비스에서 제공하는 정보를 의학적으로 맹신하여 발생한 결과에 대해 책임을 지지 않습니다. 이용자는 측정 결과에 이상이 있거나 의학적 소견이 필요한 경우, 반드시 의료기관을 방문하여 의사의 진료를 받아야 합니다.<br>
3. “회사”는 이용자의 귀책사유(잘못된 기기 조작, 정보 오입력 등)로 인한 서비스 이용의 장애 및 결과 오류에 대하여 책임을 지지 않습니다.<br><br>

<h3>제 10 조 (분쟁해결 및 재판권)</h3>
1. “회사”와 이용자 간에 발생한 분쟁에 관한 소송은 “회사”의 본점 소재지를 관할하는 지방법원을 전속관할로 합니다. 다만, 관련 법령에 명시된 필수 관할 규정이 있는 경우 그에 따릅니다.<br>
2. “회사”와 이용자 간에 제기된 소송에는 한국법을 적용합니다.<br><br>

부칙<br>
이 약관은 2026년 03월 10일부터 시행합니다.<br><br>

</body>
</html>`},
                {title: "개인정보 수집 및 이용동의", html: `<!DOCTYPE html>
<html lang="ko">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>개인정보 수집 및 이용 동의</title>
    <style>
        body {
            font-size: 15px;
            word-break: break-word;
        }
        p {
            word-break: break-word;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }
        th, td {
          border: 1px solid #000;
          padding: 8px;
          vertical-align: top;
        }
        th {
          background-color: #f4f4f4;
          font-weight: bold;
          text-align: center;
        }
        td {
          background-color: #ffffff;
        }
    </style>
</head>
<body>
  <h1>개인정보 수집 및 이용 동의</h1>
솔닥 주식회사(이하 '회사')는 원활한 건강 측정 서비스 제공을 위해 아래와 같이 최소한의 범위에서 일반 개인정보를 수집 및 이용합니다.

<h3>1. 개인정보 수집 및 이용 목적</h3>
<table>
    <thead>
      <tr>
        <th>구분</th>
        <th>수집 및 이용 목적</th>
        <th>수집 항목</th>
        <th>보유 및 이용 기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>일반 서비스</td>
        <td>
          • 이용자 식별 및 본인 확인<br>
          • 측정 결과 데이터 전송 및 공유 (알림톡 발송)<br>
          • 서비스 부정 이용 방지
        </td>
        <td>휴대전화 번호<br><br>(※ 수집된 번호는 마케팅/광고 목적으로 이용되지 않습니다)</td>
        <td>서비스 이용 계약 종료 시까지<br>(회원 탈퇴 또는 개인정보 파기 요청 시 즉시 파기)</td>
      </tr>
      <tr>
        <td>자동 수집</td>
        <td>
          • 서비스 이용 기록 관리<br>
          • 접속 빈도 파악 및 서비스 품질 개선<br>
          • 민원 상담 및 분쟁 조정을 위한 기록 보존
        </td>
        <td>접속 로그, 쿠키(Cookie), 접속 IP 정보, 기기 정보(모델명, OS, 고유식별값), 서비스 이용 기록</td>
        <td>관련 법령에 따름<br>(통신비밀보호법에 따라 접속 로그 3개월 보관)</td>
      </tr>
    </tbody>
  </table>
<br/>

<h3>2. 동의 거부 권리 및 불이익</h3>
귀하는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 단, 필수 항목인 휴대전화 번호 수집 동의를 거부할 경우 서비스 이용 및 결과 확인이 불가능합니다.<br><br>

<h3>3. 개인정보 보호책임자 및 문의</h3>
- 담당자: 김민승/CEO<br>
- 연락처: 02-6954-7676<br>

</body>
</html>`},
                {title: "민감정보(건강데이터) 처리 동의", html: `<!DOCTYPE html>
<html lang="ko">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>민감정보(건강데이터) 처리에 대한 동의</title>
    <style>
        body {
            font-size: 15px;
            word-break: break-word;
        }
        p {
            word-break: break-word;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }
        th, td {
          border: 1px solid #000;
          padding: 8px;
          vertical-align: top;
        }
        th {
          background-color: #f4f4f4;
          font-weight: bold;
          text-align: center;
        }
        td {
          background-color: #ffffff;
        }
    </style>
</head>
<body>
  <h1>민감정보(건강데이터) 처리에 대한 동의</h1>

솔닥 주식회사(이하 '회사')는 건강 측정 서비스 제공과 관련하여 개인정보보호법 제23조 제1항 제1호에 근거하여 아래와 같이 민감정보(건강정보)를 수집·이용합니다.<br><br>

<h3>1. 민감정보 수집 및 이용 내역</h3>
<table>
    <thead>
      <tr>
        <th>구분</th>
        <th>수집 및 이용 목적</th>
        <th>수집 항목</th>
        <th>보유 및 이용 기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>건강 측정 데이터</td>
        <td>
          • 건강측정기기를 통해 측정된 신체 데이터의 기록 및 분석<br>
          • 건강 리포트 생성 및 결과 제공 (알림톡 전송 등)
        </td>
        <td>
          건강측정 데이터 일체<br><br>
          • 혈압계: 수축기/이완기 혈압, 맥박수<br>
          • 신장계: 키(신장)<br>
          • 체성분분석기: 체중, 체지방률, 골격근량, 체수분량 등<br>
          • 악력계: 좌/우 악력 수치<br><br>
          (현장 기기에 따라 상이)
        </td>
        <td>서비스 이용 계약 종료 시까지<br>(회원 탈퇴 또는 개인정보 파기 요청 시 즉시 파기)</td>
      </tr>
    </tbody>
  </table>
<br/>
※ 수집되는 민감정보 항목은 현장에 설치된 건강측정기기의 종류와 구성(예: 악력계 유무 등)에 따라 일부 달라질 수 있습니다.<br><br>

<h3>2. 동의 거부 권리 및 불이익</h3>
이용자는 민감정보(건강정보) 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우 건강 측정 서비스 이용 및 결과 확인이 불가능합니다.<br>

</body>
</html>`}
            ]
        }
    },
     methods: {
        resetTimeoutCount: function () {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(this.gohome, 30000);
        },
        clearTimer: function()
        {
            clearTimeout(this.timeoutId);
            this.timerId = null;
        },
        gohome: function() {
            this.clearTimer();
            window.location.href  = '/' + this.$route.params.showcase + '/home'
        },
        allAgreeF: function()
        {
          this.reset();
            this.allAgree = !this.allAgree;
            this.agree1 = this.allAgree;
            this.agree2 = this.allAgree;
            this.agree3 = this.allAgree;
        },
        agreementContentsView: function(type)
        {
          this.reset();
            this.type = type;
            this.agreementContentsModal = true;
        },
        closeAgreementModal: function()
        {
          this.reset();
            this.type = 0;
            this.agreementContentsModal = false;
        },
        next: function()
        {
          this.reset();           
          this.$emit('next', 1)           
            
        },
        reset: function()
        {
          this.$emit('resetCount')
        }
    },
    watch: {
        agree1: function()
        {
            if(!this.agree1)
            {
                this.allAgree = false;
            }
        },
        agree2: function()
        {
            if(!this.agree2)
            {
                this.allAgree = false;
            }
        },
        agree3: function()
        {
            if(!this.agree3)
            {
                this.allAgree = false;
            }
        }
    }
}
</script>

<style scoped>
    .agreement {
        width: 100%;
        height: 100vh;
        overflow: hidden;    
    }
    .header {
        height: 9vh;
        width: 100%;
        font-size: 2vh;
        color: #000;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5%;
        box-sizing: border-box;
    }
    .agree-area {
        box-sizing: border-box;
        padding: 8vh 16vw;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-top: 2px solid var(--xi-gray-2, #C4CBD2);
    }
    .wrapper {
        padding: 6.2vh 5vw;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
    .title {
        color: #131415;
        text-align: center;
        font-family: Pretendard;
        font-size: 3vh;
        font-style: normal;
        font-weight: 500;
        line-height: 131%;
        letter-spacing: -2.64px;
    }
    .button-next {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        font-size: 1.8vh;
        width: 27vw;
        aspect-ratio: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-gray-2, #C4CBD2);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .button-next-active {
        border-radius: 16px;
        background: var(--theme-main);
        font-size: 2vh;
        width: 43vw;
        aspect-ratio: 3.8;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-gray-0, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }
    .agree-component {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .text1{
        color: var(--theme-main);
        font-family: Pretendard;
        font-size: 2.1vh;
        font-style: normal;
        font-weight: 700;
        letter-spacing: -1.12px;
        height: 6vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5vw;
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        width: 100%;
    }
    .text2 {
        color: #131415;
        font-family: Pretendard;
        font-size: 1.8vh;
        font-style: normal;
        font-weight: 500;
        letter-spacing: -0.96px;
        height: 5vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5vw;
        width: 100%;
        margin-top: 0.9vh;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Agreement.vue